const communityRouter = [
	// 推荐列表页
	{
		path: '/community',
		name: 'community-list',
		component: () => import(/* webpackChunkName: "community" */ '@/views/community/pages/community-list'),
		meta: {
			isLogin: false
		}
	},
	// 搜索页
	{
		path: '/community/search',
		name: 'community-list-search',
		component: () => import(/* webpackChunkName: "community" */ '@/views/community/pages/community-search'),
		meta: {
			isLogin: false
		}
	},
	// 话题聚合页
	{
		path: '/community/topic/:topic_id',
		name: 'article-group-detail',
		component: () => import(/* webpackChunkName: "community" */ '@/views/community/pages/article-group-detail'),
		meta: {
			isLogin: false
		}
	},
	// 攻略详情
	{
		path: '/community/blog/:token',
		name: 'blog-detail',
		component: () => import(/* webpackChunkName: "community" */ '@/views/community/pages/blog-detail'),
		meta: {
			isLogin: false,
			diffShare: true
		}
	},
	// 动态详情
	{
		path: '/community/article/:token',
		name: 'article-detail',
		component: () => import(/* webpackChunkName: "community" */ '@/views/community/pages/article-detail'),
		meta: {
			isLogin: false,
			diffShare: true
		}
	},
  // 群聚合页
  {
		path: '/groups',
		name: 'groups',
		component: () => import(/* webpackChunkName: "account" */ '@/views/community/pages/groups'),
		meta: {
			isLogin: false
		}
  }
]

export default communityRouter
